module.exports = "https://static.wmbcdn.com/uniweb/images/b2a724efae352a54a4d18b7b118401c8.svg";